/** "Hoher Kontrast" for sunlight: a per-device preference, kept in localStorage (wrapped: may throw). */
const KEY = 'fsv.contrast';

export function readHighContrast(): boolean {
  try {
    return window.localStorage.getItem(KEY) === 'high';
  } catch {
    return false;
  }
}

export function applyHighContrast(on: boolean): void {
  document.documentElement.dataset['contrast'] = on ? 'high' : 'normal';
  try {
    window.localStorage.setItem(KEY, on ? 'high' : 'normal');
  } catch {
    /* preference lasts for this tab only */
  }
}
